import { registerMutation, useMutation } from 'data-fetching-client';
import { bulkManageAccessRequest } from 'email-management-lib/refactor/api/emails';
const BULK_MANAGE_ACCESS_REQUEST = registerMutation({
  fieldName: 'bulkManageAccess',
  args: ['requestBody'],
  fetcher: ({
    requestBody
  }) => {
    return bulkManageAccessRequest(requestBody);
  }
});
export default function useBulkManageAccess() {
  const [startBulkManageAccess] = useMutation(BULK_MANAGE_ACCESS_REQUEST);
  return {
    startBulkManageAccess
  };
}